module.exports = __webpack_public_path__ + "static/img/9.e1edeff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/channel/9.png
// module id = n9OC
// module chunks = 31